import { API, graphqlOperation } from "aws-amplify";
import { createLLMMemory } from "../graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { CreateLLMMemoryMutation, CreateLLMMemoryInput } from "../API";

export async function createLLMMemoryAfterAdd(
  input: CreateLLMMemoryInput
): Promise<GraphQLResult<CreateLLMMemoryMutation>> {
  return API.graphql(
    graphqlOperation(createLLMMemory, {
      input: input,
    })
  ) as Promise<GraphQLResult<CreateLLMMemoryMutation>>;
}
